import PropTypes from 'prop-types';
import React from 'react';
import i18next from 'i18next';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, } from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';
export default class AccessorialRatesPassThruEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    handleMarkupInputChange() {
        const t = i18next.t;
        return (e) => {
            const markup = Number(e.target.value);
            this.props.onChange('markup', markup);
            let description = `${t('THE_FEE_WILL_BE_GIVEN')}${t('PERIOD')} `;
            description +=
                markup > 0
                    ? `${t('WITH_MARKUP')} ${accounting.formatMoney(markup, getCurrencySymbol(DEFAULT_CURRENCY))}`
                    : '';
            this.props.onChange('description', description);
        };
    }
    validateValue(markup) {
        if (markup >= 0) {
            return '';
        }
        return 'error';
    }
    render() {
        const accessorialRate = this.props.accessorialRate || {};
        return (React.createElement(Grid, { fluid: true },
            React.createElement(Row, { className: "show-grid" },
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, `Markup, ${getCurrencySymbol(DEFAULT_CURRENCY)}`),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.markup, onChange: this.handleMarkupInputChange(), bsStyle: this.validateValue(accessorialRate.markup) }))))));
    }
}
AccessorialRatesPassThruEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
